import React from 'react';
import { makeStyles, tokens, Button } from '@fluentui/react-components';
import { useNavigate } from 'react-router-dom';
import { PageBanner } from '@/components/common/PageBanner';

const useStyles = makeStyles({
  page: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingHorizontalXXL,
  },
});

export const NotFoundPage: React.FC = () => {
  const styles = useStyles();
  const navigate = useNavigate();
  return (
    <div className={styles.page}>
      <PageBanner
        kicker="Error 404"
        title="Page Not Found"
        subtitle="The page you are looking for does not exist or has moved."
        actions={
          <Button appearance="primary" onClick={() => navigate('/')}>
            Back to Home
          </Button>
        }
      />
    </div>
  );
};
